import { config } from "../config";

/**
 * Prepends the S3 base URL to a relative path/key.
 * Returns the input unchanged if it already starts with "http".
 * Returns empty/falsy values as-is.
 */
export const withS3Prefix = (path: string): string => {
  if (!path) return path;
  if (path.startsWith("http")) return path;
  return `${(config.assets.s3BaseUrl || "").replace(/\/$/, "")}/${path}`;
};
